module.exports = __webpack_public_path__ + "static/media/Gametime.f6155aff.png";